import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Välineet — Frisbeegolf' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Frisbeegolf"
			title="Välineet"
			intro="Mistä hankit kiekot, laukut, ja muut tarvittavat varusteet."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
